export default "__VITE_ASSET__94cc7626__"